import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
} from "./_wsApiFetchData";

export async function getExternalPurchaseAttemptById(attemptId, language, timeZone) {
  try {
    const data = await wsRequestGet(
      `/admin/externalpurchaseattempt/${attemptId}`,
      language,
      timeZone,
    );

    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the external purchase attempt by id ${attemptId}: ${e}`);
    return {
      success: false,
    };
  }
}
